// TOP LEVEL IMPORTS
import {gql} from '@apollo/client';

export default gql`
  mutation changePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
  }
`;
